// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './StepSection.style';
import DiamondIcon from 'Component/DiamondIcon/DiamondIcon.component';
import RingIcon from 'Component/RingIcon/RingIcon.component';
import RingSettingIcon from 'Component/RingSettingIcon/RingSettingIcon.component';
import CustmizeRingOptionPrice from 'Component/CustmizeRingOptionPrice/CustmizeRingOptionPrice.component';
import CustmizeRingDiamondOptionPrice from 'Component/CustmizeRingDiamondOptionPrice/CustmizeRingDiamondOptionPrice.component';
import Link from '@scandipwa/scandipwa/src/component/Link';
import PendantIcon from 'Component/PendantIcon';
import { custmizesku } from 'Src/Value/customization';
import history from '@scandipwa/scandipwa/src/util/History';
import ChooseStonePopup from '../../component/ChooseDiamondPopUp/ChooseDiamondPopUp.component';
import PendentSettingIcon from 'Component/PendentSettingIcon';

export class StepSection extends PureComponent {
    static propTypes = {
        category: this.propTypes,
        ringsetting: this.propTypes,
        ringdiamond: this.propTypes,
        hasColor: this.propTypes
    };

    constructor(props) {
        super(props);
        this.state = {
            isPopupOpen: false
        };
    }

    handleLinkClick = (event) => {
        event.preventDefault();
        this.setState({ isPopupOpen: true });
    };

    closePopup = () => {
        this.setState({ isPopupOpen: false });
    };

    state = {
        category: ""
    };

    componentDidMount() {
        const { category } = this.props;
        const ringsetting = JSON.parse(localStorage.getItem("setting"));
        const ringdiamond = JSON.parse(localStorage.getItem("diamond"));

        if (category === "Setting" && !ringdiamond) {
            localStorage.setItem("step", "Setting");
            this.setState({
                category: "Setting"
            });
        } else if (category === "Diamond" && !ringsetting) {
            localStorage.setItem("step", "Diamond");
            this.setState({
                category: "Diamond"
            });
        } else {
            this.setState({
                category: category
            });
        }
    }

    renderStep = () => {
        const { category } = this.state;
        let { ringsetting, ringdiamond, hasColor } = this.props;
        const step = localStorage.getItem("step");
        const finalsku = localStorage.getItem("custmizesku");

        if (!ringsetting) {
            ringsetting = JSON.parse(localStorage.getItem("setting"));
        }

        if (!ringdiamond) {
            ringdiamond = JSON.parse(localStorage.getItem("diamond"));
        }

        const diamond_link = hasColor || ringdiamond?.hasColor ? "/coloreddiamond?diamond_created_from=11" : "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11";
        const setting_link = "/customize/ring-settings.html";
        const ispendentorearring = history.location.pathname.includes(custmizesku.finalpendant.url);

        if (finalsku === custmizesku.finalpendant.sku || ispendentorearring) {
            return (
                <div className='steps-section'>
                    <div className={this.props.category === "Setting" ? "step-container first-step-conteiner step-container_active" : 'step-container'}>
                        <div className='step-options'>
                            <span className='step-number'>1</span>
                            <div className='step-option-content'>
                                <p>Select Your </p>
                                <span>Setting</span>
                            </div>
                            {
                                ringsetting ?
                                    <CustmizeRingOptionPrice
                                        product={ringsetting}
                                        showoptions={true}
                                    /> : finalsku === custmizesku.finalpendant.sku ? <PendentSettingIcon /> : <></>
                            }
                        </div>
                    </div>

                    <div className={this.props.category === "Diamond" ? "step-container step-container_active" : 'step-container'}>
                        <div className='step-options'>
                            <span className='step-number'>2</span>
                            <div className='step-option-content'>
                                <p>Select Your </p>
                                <span>Stone</span>
                            </div>
                            {
                                ringdiamond ?
                                    <CustmizeRingDiamondOptionPrice
                                        product={ringdiamond}
                                        showoptions={true}
                                    /> : <DiamondIcon />
                            }
                        </div>
                    </div>

                    <div className={!category ? "step-container last-step-conteiner step-container_active" : 'step-container'}>
                        <div className='step-options'>
                            <span className='step-number'>3</span>
                            <div className='step-option-content'>
                                <p>Complete Your</p>
                                <span>Pendant</span>
                            </div>
                            {finalsku === custmizesku.finalpendant.sku ? <PendantIcon /> : <></>}
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div className='steps-section'>
                {
                    (category === "Diamond" && step === "Diamond")
                        || (category === "Diamond" && step === null)
                        || (category === "Setting" && step === "Diamond")
                        || (!category && step === "Diamond")
                        ? <>
                            <div
                                className={this.props.category === "Diamond" ? "step-container first-step-conteiner step-container_active" : 'step-container'}
                            >
                                <Link
                                    to={diamond_link}
                                    // onClick={this.handleLinkClick}
                                >
                                    <div className='step-options'>
                                        <span className='step-number'>1</span>
                                        <div className='step-option-content'>
                                            <p>Select Your </p>
                                            <span>Stone</span>
                                        </div>
                                        {
                                            ringdiamond ?
                                                <CustmizeRingDiamondOptionPrice
                                                    product={ringdiamond}
                                                    showoptions={true}
                                                /> : <DiamondIcon />
                                        }
                                    </div>
                                </Link>
                            </div>

                            <div
                                className={this.props.category === "Setting" ? "step-container step-container_active" : 'step-container'}
                            >
                                <Link
                                    to={setting_link}
                                >
                                    <div className='step-options'>
                                        <span className='step-number'>2</span>
                                        <div className='step-option-content'>
                                            <p>Select Your </p>
                                            <span>Setting</span>
                                        </div>
                                        {
                                            ringsetting ?
                                                <CustmizeRingOptionPrice
                                                    product={ringsetting}
                                                    showoptions={true}
                                                /> : <RingSettingIcon />
                                        }
                                    </div>
                                </Link>
                            </div>
                        </>
                        : (category === "Setting" && step === "Setting")
                            || (category === "Setting" && step === null)
                            || (category === "Diamond" && step === "Setting")
                            || (!category && step === "Setting")
                            ? <>
                                <div
                                    className={this.props.category === "Setting" ? "step-container first-step-conteiner step-container_active" : 'step-container'}
                                >
                                    <Link
                                        to={setting_link}
                                    >
                                        <div className='step-options'>
                                            <span className='step-number'>1</span>
                                            <div className='step-option-content'>
                                                <p>Select Your </p>
                                                <span>Setting</span>
                                            </div>
                                            {
                                                ringsetting ?
                                                    <CustmizeRingOptionPrice
                                                        product={ringsetting}
                                                        showoptions={true}
                                                    /> : <RingSettingIcon />
                                            }
                                        </div>
                                    </Link>
                                </div>

                                <div
                                    className={this.props.category === "Diamond" ? "step-container step-container_active" : 'step-container'}
                                >
                                    <Link
                                        to={diamond_link}
                                    >
                                        <div className='step-options'>
                                            <span className='step-number'>2</span>
                                            <div className='step-option-content'>
                                                <p>Select Your </p>
                                                <span>Stone</span>
                                            </div>
                                            {
                                                ringdiamond ?
                                                    <CustmizeRingDiamondOptionPrice
                                                        product={ringdiamond}
                                                        showoptions={true}
                                                    /> : <DiamondIcon />
                                            }
                                        </div>
                                    </Link>
                                </div>
                            </> : ""
                }

                <div className={!category ? "step-container step-container_active" : 'step-container'}>
                    <div className='step-options'>
                        <span className='step-number'>3</span>
                        <div className='step-option-content'>
                            <p>Complete Your</p>
                            <span>Ring</span>
                        </div>
                        <RingIcon />
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="StepSection">
                <div className='steps-section-contianer'>
                    {this.renderStep()}
                    {this.state.isPopupOpen && <ChooseStonePopup onClose={this.closePopup} />}
                </div>
            </div>
        );
    }
}

export default StepSection;
